
//------------------
// Components 
//------------------

// import aura from './components/aura-canvas.js';

// import { show_logo, hide_logo } from './components/logo.js';
// import landing from './components/landing.js';
import ProjectObserver from './components/project-observer.js';
import InfiniteScroll from './components/infinate-scroll.js';
import VideoPlayerActivator from'./components/VideoPlayerActivator.js';
import FilterManager from './components/FilterManager.js';

import player from '@vimeo/player';


// import load_embeds from './components/lazy-load-embed.js';
// import bind_video_players from './components/bind-video-players.js';


window.his = window.location.pathname;
window.touch = isTouchDevice();

window.browser = detectBrowser();
document.body.classList.add(window.browser.replace(' ', '').toLowerCase());

function isTouchDevice() {
    return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
}


let observer = null;
let players = null;
let scroller = null;
let filters = null;


//------------------
// CORE 
//------------------

const menuTrig = document.querySelector('.menu-button');


window.fullscreen = 0;

var mousewheel = false;
var curScroller = false;



function half_load(){

    check_for_scroller();
    
    project_overlay();
    bild_ajax_load();
    load_embeds();

}

function first_load(){
    load_in();
    setupTripleSpacePlayMode();
};

function page_load(){

  document.body.style.backgroundColor = '';
    const featuredItems = document.querySelectorAll('.featured');
  

    if (featuredItems.length > 0) {

        const parent = document.querySelector('.featured').parentNode;
        const randomIndex = Math.floor(Math.random() * featuredItems.length);
        const randomFeatured = featuredItems[randomIndex];
        parent.insertBefore(randomFeatured, parent.firstChild);

    }

    bild_ajax_load();

    scroller = new InfiniteScroll();  
    observer = new ProjectObserver();
    players = new VideoPlayerActivator('.video-player');

  

    filters = new FilterManager({
        onFilterChange: (val) => {
            
            if (val === 'all-projects') {
                rebuildScroller();
            } else {
                if (scroller && scroller.valid) {
                    scroller.destroy();
                }
            }

            if (observer && observer.valid && typeof observer.update === 'function') {
                observer.update(); // should trigger alert
            }

        }

    });


    updateActivePageLinks();
   
};

window.onload = function(event) {
    first_load();
    page_load();
};


function load_in(){
    
    const beat = 67;
    const logo = document.querySelector('#logo-wrap');
    const nav = document.querySelector('nav');

    const content = document.querySelectorAll('.fade-in');


    setTimeout(function(){
        logo.style.opacity = 1;
    }, beat * 5);

     setTimeout(function(){
        nav.style.opacity = 1;
        
    }, beat * 7);

    setTimeout(function(){
        for (let a = 0; a < content.length; a++) {
            const element = content[a];
            element.style.opacity = 1;
        }
    }, beat * 11);


}


function bild_ajax_load(){

    var links = document.querySelectorAll('a:not(.bound)');

    for (let a = 0; a < links.length; a++) {
       let elm = links[a];

        if(isInternalLink(elm) && !elm.classList.contains('bound')){
            elm.classList.add('bound');
            elm.addEventListener('click', load_content);
        }
        
    }

}

function destroy_functions() {
  // Properly check for validity before destroying
  if (scroller && scroller.valid) {
    scroller.destroy();
    scroller = null; // Clear reference
  }
  
  if (observer && observer.valid) {
    observer.destroy();
    observer = null;
  }

  if (players && players.valid) {
    players.destroy();
    players = null;
  }

  if (filters && filters.valid) {
    filters.destroy();
    filters = null;
  }
  
  // Clean up any lingering event listeners
  const boundLinks = document.querySelectorAll('a.bound');
  boundLinks.forEach(link => {
    link.removeEventListener('click', load_content);
    link.classList.remove('bound');
  });

}

function rebuildScroller() {
  if (scroller && scroller.valid) scroller.destroy();
  scroller = new InfiniteScroll();
}

function load_page(full, path){

    if(full){
        window.his = path;
    }

    destroy_functions();

    var cur = document.querySelector('main');
    var parent = cur.parentNode;

    cur.style.opacity = 0;

    let page = document.querySelector('.content');
    page.style.height = (window.innerHeight * 3) + 'px';

    window.history.pushState({}, '', path);

    fetch(path)
    .then(function(response) {
      return response.text();
    })
    .then(function(data) {

        let html =  extractInnerContent(data);
        var content = html.querySelector('main');

        if(content){
            content.style.opacity = 1;
            document.body.classList = content.classList;
        }


        if(content){
            parent.append(content);
        }

       

        cur.parentNode.removeChild(cur);

        const logo = document.querySelector('#logo-wrap');
        let headerHeight = (window.innerWidth * 0.22406);

        var top = (window.pageYOffset || document.scrollTop)  - (document.clientTop || 0);
      
        if(top > 3){
          if(document.querySelector('.iframe-touch-overlay')){

            const el = document.querySelector('.film-content');
            const style = window.getComputedStyle(el);
            const rect = el.getBoundingClientRect();
            const paddingTopPx = style.paddingTop;
            const paddingTopNum = parseFloat(paddingTopPx);
            window.scrollTo({ top: paddingTopNum + 30 });

          }else{
             window.scrollTo({ top: headerHeight });
          }
           
        }

        page.style.height = '';
       
        if(content){
            const fadein = content.querySelectorAll('.fade-in');
            for (let a = 0; a < fadein.length; a++) {
                const element = fadein[a];
                element.style.opacity = 1;
            }
            
        }

         page_load();

     
    })
    .catch(function(error) {
      console.error('Error:', error);
    });
    
};
  


function load_content(e){

    e.preventDefault();
    
    
    let elm = this;
    
    if(elm.classList.contains('active-page')) return;

    let newUrl = elm.href;
    let path = getUrlPathFromHref(newUrl);

    var full = true;

    if(elm.classList.contains('project-link')){

        full = false;

        if(document.querySelector('.project-overlay')){
            return false
        }

        if(elm.classList.contains('desktop-link') && window.touch){
            return false;
        }
    }
  
    load_page(full, path);
    
}


function isInternalLink(link) {
   
    var currentHostname = window.location.hostname;
    var linkHostname = getHostnameFromHref(link.href);

    // Compare the hostnames
    if(link.href.includes('action')){
        return false;
    }else{
        return currentHostname === linkHostname;
    }

}


  
function getHostnameFromHref(href) {

    if(href){
        var url = new URL(href);
        return url.hostname;
    }else{
        return false;
    }
}
  


  function getUrlPathFromHref(href) {
    var link = document.createElement('a');
    link.href = href;

    return link.pathname;
 
  }


function extractInnerContent(htmlString) {
    var tempElement = document.createElement('div');
    tempElement.innerHTML = htmlString;
    return tempElement;
}



function debounce(func, wait = 20, immediate = true) {
    let timeout;
    return function () {
      const context = this, args = arguments;
      const later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }
  


  function detectBrowser() {
    const userAgent = navigator.userAgent;
    const isIOS = /iPad|iPhone|iPod/i.test(userAgent) && !window.MSStream; // Checks for iOS devices
    const isSafari = /safari/i.test(userAgent) && !/chrome|chromium|crios|edg|opr/i.test(userAgent); // Ensures it's Safari

    if (isSafari && isIOS) {
        return "iOS Safari";
    } else if (isSafari) {
        return "macOS Safari";
    } else if (/chrome|chromium|crios/i.test(userAgent)) {
        return "Google Chrome";
    } else if (/firefox|fxios/i.test(userAgent)) {
        return "Mozilla Firefox";
    } else if (/edg/i.test(userAgent)) {
        return "Microsoft Edge";
    } else if (/opr\//i.test(userAgent)) {
        return "Opera";
    } else if (/msie|trident/i.test(userAgent)) {
        return "Microsoft Internet Explorer";
    } else {
        return "Unknown Browser";
    }
}



function setupTripleSpacePlayMode() {
    
  let spacePresses = [];
  const threshold = 1000; // ms between first and last of 3 taps

  let mousemove = 0;

  function enterPlayMode() {

    mousemove = 0;
    document.body.classList.add('playmode');
    window.playmode = true;


    // const logo = document.querySelector('#logo-wrap');
    // let headerHeight = (window.innerHeight * 0.2227) + logo.offsetHeight;


    // if(headerHeight > document.body.scrollTop){
    //     window.scrollTo({ top: headerHeight });
    // }

    

    if (document.documentElement.requestFullscreen) {
      document.documentElement.requestFullscreen().catch(err => {
        console.warn('Fullscreen request failed:', err);
      });
    }

    // Listen for mousemove to exit playmode
    window.addEventListener('mousemove', exitPlayModeOnce);
  }

  function exitPlayModeOnce() {

    if(mousemove < 100){
        mousemove++;
        return;
    }

    if (!window.playmode) return;

    document.body.classList.remove('playmode');
    window.playmode = false;


    if (document.fullscreenElement) {
      document.exitFullscreen().catch(err => {
        console.warn('Exit fullscreen failed:', err);
      });
    }

    window.removeEventListener('mousemove', exitPlayModeOnce);

  }

  window.addEventListener('keydown', function (e) {
    if (e.code === 'Space') {
      
        e.preventDefault();

      const now = Date.now();
      spacePresses.push(now);
      if (spacePresses.length > 3) spacePresses.shift();

      if (
        spacePresses.length === 3 &&
        spacePresses[2] - spacePresses[0] < threshold
      ) {
        spacePresses = [];
        enterPlayMode();
      }
    }
  });
};



    const debug = document.querySelector('.debug');

   


     window.addEventListener('scroll', calcViewPortCenter);


  function calcViewPortCenter(){

    const scrollY = window.scrollY || window.pageYOffset;
    const headerHeight = window.innerWidth * 0.22406;

   

    let obs = Math.max(0, 200 - scrollY/1.6);
    let tempOff = headerHeight + obs;

    if (tempOff < headerHeight) {
      tempOff = headerHeight;
    }
     if(debug){
      debug.style.top = `${tempOff}px`;
    }


  }

  window.addEventListener('popstate', function(event) {
    location.reload(true);
  });



  function updateActivePageLinks() {

    const links = document.querySelectorAll('a');
    let active = false;
    let nav = document.querySelector('nav');

    links.forEach(link => {
        
        const path = getUrlPathFromHref(link.href);
        const isSamePage = path === window.location.pathname;

        if (isSamePage) {
            active = link;
            link.classList.add('active-page');
        } else {
            link.classList.remove('active-page');
        }
    });

    if(active){
        if(active.parentNode.parentNode === nav){
            nav.classList.add('in-use');
        }else{
            nav.classList.remove('in-use');
        }
    }
}


